import { render, staticRenderFns } from "./pioneer6-comparision.vue?vue&type=template&id=24b37faf&scoped=true"
import script from "./pioneer6-comparision.vue?vue&type=script&lang=js"
export * from "./pioneer6-comparision.vue?vue&type=script&lang=js"
import style0 from "./pioneer6-comparision.vue?vue&type=style&index=0&id=24b37faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b37faf",
  null
  
)

export default component.exports